import styled from 'styled-components';

export const ThermalComfortContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;

  & > #upgrade-module-container {
    flex: 1 1 100%;
  }
`;

export const CurrentThermalComfortContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
